/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Copilot_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Remove Compliance Copilot" |
*
* @param {Sub_Addons_Confirm_Copilot_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_copilot_remove_title = /** @type {((inputs?: Sub_Addons_Confirm_Copilot_Remove_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Copilot_Remove_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot entfernen")
	return /** @type {LocalizedString} */ ("Remove Compliance Copilot")
});